/**
 * Helpers and data for mock mode to help with testing
 *
 * Run mock() in the console to activate mock mode
 * Run unmock() in the console to deactivate mock mode
 */

const MOCK_KEY = '__trashie_mock_trackers__';
export const MOCK_EVENT = 'trashie:mock-trackers-change';

export function isMockActive() {
  try {
    return sessionStorage.getItem(MOCK_KEY) === '1';
  } catch {
    return false;
  }
}

function notifyListeners() {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(MOCK_EVENT));
  }
}

function activateMock() {
  try {
    sessionStorage.setItem(MOCK_KEY, '1');
  } catch { /* no-op */ }
  notifyListeners();
  // eslint-disable-next-line no-console
  console.log('[Trashie] Mock trackers ACTIVE — showing mock data. Call unmock() to disable.');
}

function deactivateMock() {
  try {
    sessionStorage.removeItem(MOCK_KEY);
  } catch { /* no-op */ }
  notifyListeners();
  // eslint-disable-next-line no-console
  console.log('[Trashie] Mock trackers DISABLED — showing real data.');
}

export function registerMockGlobals() {
  if (typeof window === 'undefined') return;
  window.mock = activateMock;
  window.unmock = deactivateMock;
}

const API_STEP_KEYS = [
  'bag_registered',
  'carrier_scan_detected',
  'sorting_center_received',
  'sorting_center_completed',
];

export default function getMockShipments() {
  const baseDate = new Date('2026-03-01T10:00:00.000Z');
  const stages = [
    { completedCount: 1, itemsCount: 1 },
    { completedCount: 2, itemsCount: 1 },
    { completedCount: 2, itemsCount: 2, isQR: false },
    { completedCount: 2, itemsCount: 3 },
    { completedCount: 2, itemsCount: 4 },
    { completedCount: 3, itemsCount: 2 },
    { completedCount: 4, itemsCount: 1 },
    { completedCount: 5, itemsCount: 3 },
    { lost: true, itemsCount: 2 },
  ];
  return stages.map((stage, idx) => {
    const n = stage.lost ? 3 : stage.completedCount - 1;
    const steps = stage.lost
      ? [
        { key: 'bag_registered', completed: true, completedAt: baseDate.toISOString() },
        {
          key: 'carrier_scan_detected',
          completed: true,
          completedAt: baseDate.toISOString(),
          data: { amountEarned: 5 },
        },
        {
          key: 'sorting_center_received',
          completed: true,
          completedAt: baseDate.toISOString(),
          data: { isLost: true },
        },
        { key: 'sorting_center_completed', completed: false, completedAt: null },
      ]
      : API_STEP_KEYS.map((key, i) => ({
        key,
        completed: i < n,
        completedAt: i < n ? baseDate.toISOString() : null,
      }));
    const date = new Date(baseDate);
    date.setDate(date.getDate() + idx);
    return {
      batchId: `mock-batch-${idx + 1}`,
      shippingProviderId: stage.isQR === false ? 'EASYPOST' : 'FEDEX',
      isQR: stage.isQR !== false,
      items: Array.from({ length: stage.itemsCount }, (_, i) => ({
        reference: `mock-${idx}-${i}`,
      })),
      steps,
      date: date.toISOString(),
    };
  });
}
